// extracted by mini-css-extract-plugin
export default {"content":"about_content__yVJVG"};